import { useState } from 'react'
import ArrowDown from '@/assets/common/arrowDown.inline.svg'
import classNames from 'classnames'

const Accordion = ({
  children,
  label,
  openAccordion = false,
  showSelectedDot = false,
  containerClassName = '',
}: {
  children?: JSX.Element
  label: string
  openAccordion?: boolean
  showSelectedDot?: boolean
  containerClassName?: string
}) => {
  const [toggle, setToggle] = useState(openAccordion)
  return (
    <div
      className={`${
        toggle ? 'bg-white' : 'bg-brand-grey-background'
      } cursor-pointer border-b p-4 ${containerClassName}`}
      onClick={e => {
        e.stopPropagation()
        setToggle(prevState => !prevState)
      }}
    >
      <div>
        <div className="text-brand-grey-base flex justify-between text-sm">
          <span className="flex flex-row items-center justify-around">
            {showSelectedDot && (
              <div className="bg-chart-blue mr-2 h-2  w-2 rounded-[50%]" />
            )}
            {label}
          </span>
          <ArrowDown width={20} height={20} />
        </div>
        {toggle && <div>{children}</div>}
      </div>
    </div>
  )
}

export default Accordion
